import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const Meta = () => {
    const location = useLocation();
    const [metaData, setMetaData] = useState({
        title: "Codeinputs",
        description: "Default description",
        keywords: "default, keywords",
        favicon: "/images/favicon.webp"
    });

    useEffect(() => {
        const fetchMeta = async () => {
            try {
                const response = await fetch("https://codeinputs.com/reactapi/api/codeinputs/get_page_detail", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ url: location.pathname }),
                });
                const data = await response.json();
                console.warn(location.pathname);
                setMetaData({
                    title: data.detail.title,
                    description: data.detail.description,
                    keywords: data.detail.keywords,
                    favicon: "/images/favicon.webp"
                });
            } catch (error) {
                console.error("Error fetching meta data:", error);
            }
        };

        fetchMeta();
    }, [location.pathname]);

    return (
        <Helmet>
            <title>{metaData.title}</title>
            <meta name="description" content={metaData.description} />
            <meta name="keywords" content={metaData.keywords} />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" /> 
            <link rel="icon" type="image/png" href={metaData.favicon} />
            <link rel="preload" as="image" href="/images/Email_accounts.webp" type="image/webp"/>
            
        </Helmet>
    );
};

export default Meta;
